import "./InventoryListing.css";
import React, { Fragment } from "react";
// import { Link } from "react-router-dom";

// Common Components Start
// import PropertyContent from "../../../components/PropertiesContent/PropertiesContent";
import PropertiesContent from "../PropertiesContent/PropertiesContent";
import CommonLoader from "../scripts/CommonLoader";
// Common Components End

// Functions Start
// import { getAuth } from "firebase/auth";
// import { getDownloadURL, getStorage, listAll, ref } from "firebase/storage";
// Functions End

// Controller Start
// import GetProperties from "../../../controllers/properties/getProperties";
// import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
// import getSettings from "../../../controllers/settings/getSettings";
// Controller End

import InfiniteScroll from "react-infinite-scroll-component";
// import Sidebar from "../Sidebar/Sidebar";
// import PublicPropertyContent from "../PublicPropertyContent/PublicPropertyContent";
// import SharedPropertyContent from "../SharedPropertyContent/SharedPropertyContent";

// import GetPublicProperties from "../../../controllers/properties/getPublicProperties";
import { useInventoryProperties } from "../scripts/InventoryProperties";
import NoDataFound from "../../../components/Common/NoDataFound/NoDataFound";

const InventoryListing = ({
  Type,
  FiltersParams,
  areFiltersSetToDefault,
  handleOpenModal,
}) => {
  const [Properties, fetchProperties, hasMore] = useInventoryProperties(
    Type,
    FiltersParams,
    areFiltersSetToDefault
  );

  return (
    <>
      <InfiniteScroll
        dataLength={Properties.length}
        next={fetchProperties}
        // hasMore={true}
        hasMore={hasMore}
        loader={<CommonLoader />}
        scrollThreshold={1}
        style={{ overflow: "inherit" }}
      >
        <div className="row">
          {/* here */}
          {Properties &&
            Properties.map((item, index) => (
              <PropertyCard
                key={index}
                tab={"inventory"}
                type={Type}
                property={item}
                handleOpenModal={handleOpenModal}
              />
            ))}
        </div>
      </InfiniteScroll>
      {!hasMore && Properties?.length === 0 ? (
        <Fragment>
          <div className="properties-custom-nothing-container">
            <NoDataFound />
          </div>
        </Fragment>
      ) : (
        ""
      )}
    </>
  );
};

function PropertyCard({ type, property, handleOpenModal, tab, key }) {
  return (
    <PropertiesContent
      type={type}
      property={property}
      tab={tab}
      key={key}
      CurrencySettings={{
        country: "Pakistan",
        currency: "PKR",
        currencyFormat: "numeral",
      }}
      handleOpenModal={handleOpenModal}
    />
  );
}
// cls;
export default InventoryListing;
